/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const TriggerEnum = core.serialization.enum_(["first", "hover", "event", "manual"]);
